import { AntDesign } from '@expo/vector-icons';
import { themeSelector } from '@reduxLocal/selectors/themeSelector';
import React from 'react';
import { XStack, Text, YStack } from 'tamagui';
import { Linking } from 'react-native';

interface InformationalTextProps {
  text: string;
  link?: string;
}

const InformationalText = ({
  text, link
}: InformationalTextProps) => {
  const theme = themeSelector();

  return (
    <YStack minHeight={30} height={50}>
      <XStack style={{ flexDirection: 'row', gap: 10, marginVertical: 5, minHeight: 60 }}>
        <AntDesign onPress={()=>{
          if (link) {
            Linking.openURL(link);
          }
        }} name="question-circle" size={14} color={theme ? '#64748b' : '#94a3b8'} />
        <Text onPress={() => {
          if (link) {
            Linking.openURL(link);
          }
        }} style={{
          flex: 1,
          textDecorationLine: link ? 'underline' : 'none',
          color: theme ? '#64748b' : '#94a3b8',
          fontSize: 14,
          lineHeight: 20
        }}>{text}</Text>
      </XStack>
    </YStack>
  )
}
export default InformationalText;
